export function isAuthenticatedContext(context) {
    return context.principal !== null;
}
//# sourceMappingURL=contextGuard.js.map